import type { OrganizationCapabilities } from '../console.api.types';
import type { PLAN_TYPE } from './shared';
import type { MfaStatus } from './user';

export enum ORGANIZATION_ROLE_NAME {
  ORG_OWNER = 'organization-owner',
  ORG_ADMIN = 'organization-admin',
  ORG_MEMBER = 'organization-member',
}
export type OrgFeatureToggles = {
  'console-flexible-storage-options': boolean;
  enable_billing_account_for_console: boolean;
  enable_organization_sso: boolean;
  enable_seamless_connection: boolean;
  'plg-new-onboarding': boolean;
  'plg-home-page-types': 'trial' | 'none';
  'plg-sample-applications': boolean;
};

export type OrganizationProfile = 'internal' | 'external' | 'canary';

export interface Organization {
  id: string;
  ssoOrgId?: string;
  name: string;
  displayName: string;
  passwordLoginEnabled: boolean;
  googleLoginEnabled: boolean;
  microsoftLoginEnabled: boolean;
  createdAt?: string;
  planType: PLAN_TYPE;
  copilotEnabled: boolean;
  capabilities: OrganizationCapabilities;
  gdsSessions: {
    enabled: boolean;
    maxConcurrentSessions: number;
    maxMemoryPerSession: string;
  };
  featureToggles: OrgFeatureToggles;
  profile: OrganizationProfile;
  onboardingCompleted: boolean;
  trialEndTime?: string;
  appMfaRequired: boolean;
  ipFilterId?: string;
}

export type OrganizationRole = {
  id: string;
  userId: string;
  name: ORGANIZATION_ROLE_NAME;
  organizationId?: string;
};

export type OrganizationMember = {
  id: string;
  email: string;
  roles: OrganizationRole[];
  organizationId: string;
  appMfaStatus: MfaStatus;
  hasMultipleOrgs: boolean;
};

export type TrialCustomerInfo = {
  firstName?: string;
  lastName?: string;
  jobRole?: string;
  jobRoleOther?: string;
  primaryUseCase?: string;
  primaryUseCaseOther?: string;
  companyName?: string;
  primaryBusinessLocationCountry?: string;
  primaryBusinessLocationSubDivision?: string;
};

export type ProfilingInfo = {
  firstName?: string;
  lastName?: string;
  companyName?: string;
  jobRole?: string;
  jobRoleOther?: string;
  primaryUseCase?: string;
  primaryUseCaseOther?: string;
  onboardingIntent?: string;
  onboardingIntentOther?: string;
  marketingPreference?: boolean;
};

export type OrganizationSsoId = {
  id: string;
  ssoId: string;
};

export type InstanceSeamlessProfile = {
  id: string;
  name: string;
  seamlessConnectionEnabled: boolean;
  immutable: boolean;
  immutableReason: string | null;
};

export type ProjectSeamlessProfile = {
  id: string;
  name: string;
  defaultSeamlessConnectionEnabled: boolean;
  instances: InstanceSeamlessProfile[];
};

export type OrganizationSeamlessProfile = {
  id: string;
  name: string;
  projects: ProjectSeamlessProfile[];
};

export enum CHURN_REASON {
  EXPENSIVE = 'expensive',
  DIFFICULT = 'difficult',
  FEATURES = 'features',
  PERFORMANCE = 'performance',
  FOUND_ALTERNATIVE = 'found_alternative',
  DOCUMENTATION = 'documentation',
  OTHER = 'other',
}

export type ChurnSurvey = {
  id: string;
  organizationId: string;
  userId: string;
  dbid: string;
  reasons: CHURN_REASON[];
  comment: string | null;
};
